export const isValidHexColor = (value)=>/^#[0-9A-F]{3}$|^#[0-9A-F]{6}$/i.test(value);
